import {Examen} from '../../../../../models/examen';
import {environment} from './../../../../../../environments/environment.prod';
import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Subject} from 'rxjs';
import {debounceTime, startWith, takeUntil} from 'rxjs/operators';
import {Autres} from '../../../../../models/autres';
import {ConduiteService} from '../../../../../core/apps/conduite.service';
import {avertissementsExamen} from '../../../../../core/apps/examen-avertissements';
import {ImageService} from '../../../../../core/apps/image.service';
import firebase from 'firebase';
import {AngularFireStorage} from '@angular/fire/storage';
import {AngularFirestore} from '@angular/fire/firestore';

const DEFAULT_NO_FINDING = 'Rien à signaler';

interface FindingControlConfig {
	listControl: string;
	inputControl: string;
	frequencyControl?: string;
	severityControl?: string;
	collection?: string;
	listProperty?: string;
}

const FINDING_CONTROL_CONFIGS: FindingControlConfig[] = [
	{ listControl: 'embonpointobservation', inputControl: 'embonpointobservationinput', frequencyControl: 'embonpointfrequences', severityControl: 'embonpointseverite', collection: 'Embonpoints', listProperty: 'embonpoints' },
	{ listControl: 'revetement', inputControl: 'revetementinput', frequencyControl: 'revetementsfrequences', severityControl: 'revetementsseverite', collection: 'Revetementcutane', listProperty: 'revetements' },
	{ listControl: 'nageoires', inputControl: 'nageoiresinput', frequencyControl: 'nageoiresfrequences', severityControl: 'nageoiresseverite', collection: 'Nageoires', listProperty: 'nageoires' },
	{ listControl: 'opercule', inputControl: 'operculeinput', frequencyControl: 'operculefrequences', severityControl: 'operculeseverite', collection: 'Opercule', listProperty: 'opercules' },
	{ listControl: 'bouche', inputControl: 'boucheinput', frequencyControl: 'bouchefrequences', severityControl: 'boucheseverite', collection: 'Bouche', listProperty: 'bouches' },
	{ listControl: 'estomac', inputControl: 'estomacinput', frequencyControl: 'estomacfrequences', severityControl: 'estomacseverite', collection: 'Estomac', listProperty: 'estomacs' },
	{ listControl: 'intestin', inputControl: 'intestininput', frequencyControl: 'intestinfrequences', severityControl: 'intestinseverite', collection: 'Intestin', listProperty: 'intestins' },
	{ listControl: 'branchie', inputControl: 'branchieinput', frequencyControl: 'branchiefrequences', severityControl: 'branchieseverite', collection: 'Branchie', listProperty: 'branchies' },
	{ listControl: 'coeur', inputControl: 'coeurinput', frequencyControl: 'coeurfrequences', severityControl: 'coeurseverite', collection: 'Coeur', listProperty: 'coeurs' },
	{ listControl: 'tete', inputControl: 'teteinput', frequencyControl: 'tetefrequences', severityControl: 'teteseverite', collection: 'Tete', listProperty: 'tetes' },
	{ listControl: 'yeux', inputControl: 'yeuxinput', frequencyControl: 'yeuxfrequences', severityControl: 'yeuxseverite', collection: 'Yeux', listProperty: 'yeux' },
	{ listControl: 'cerveau', inputControl: 'cerveauinput', frequencyControl: 'cerveaufrequences', severityControl: 'cerveauseverite', collection: 'Cerveau', listProperty: 'cerveaus' },
	{ listControl: 'rate', inputControl: 'rateinput', frequencyControl: 'ratefrequences', severityControl: 'rateseverite', collection: 'Rate', listProperty: 'rates' },
	{ listControl: 'foie', inputControl: 'foieinput', frequencyControl: 'foiefrequences', severityControl: 'foieseverite', collection: 'Foie', listProperty: 'foies' },
	{ listControl: 'vesiculeBiliaire', inputControl: 'vesiculeBiliaireinput', frequencyControl: 'vesiculeBiliairefrequences', severityControl: 'vesiculeBiliaireseverite', collection: 'Vesiculebiliaire', listProperty: 'vesiculeBiliaires' },
	{ listControl: 'rein', inputControl: 'reininput', frequencyControl: 'reinfrequences', severityControl: 'reinseverite', collection: 'Rein', listProperty: 'reins' },
	{ listControl: 'vessienatatoire', inputControl: 'vessienatatoireinput', frequencyControl: 'vessienatatoirefrequences', severityControl: 'vessienatatoireseverite', collection: 'Vessienatatoire', listProperty: 'vessienatatoires' },
	{ listControl: 'autres', inputControl: 'autresinput', frequencyControl: 'autresfrequences', severityControl: 'autresseverite', collection: 'autres', listProperty: 'autres' },
	{ listControl: 'parasitaire', inputControl: 'rechercheparasitaire', collection: 'Parasitaire', listProperty: 'parasitaires' },
	{ listControl: 'bacteriologique', inputControl: 'recherchebacteriologique', collection: 'Bacteriologique', listProperty: 'bacteriologiques' },
	{ listControl: 'diagnostic', inputControl: 'diagnostictexte', collection: 'diagnostics', listProperty: 'diagnostics' },
	{ listControl: 'conduite', inputControl: 'conduitetexte', collection: 'Conduites', listProperty: 'conduites' },
];

class ImageSnippet {
	pending: boolean = false;
	status: string = "init";
	constructor(public src: string, public file: File) {}
}

@Component({
  selector: 'kt-addexamen',
  templateUrl: './addexamen.component.html',
  styleUrls: ['./addexamen.component.scss']
})

export class AddexamenComponent implements OnInit, OnDestroy {
	progress: number;
	tripForm: FormGroup;
	fileIsUploading: boolean[] = [false, false, false, false, false];
	fileUrls: string[] = ['', '', '', '', ''];
	fileUploaded = false;
	filteredMolecules: string[] = [];
	filteredDureetraitements: string[] = [];
	private destroy$: Subject<void> = new Subject();

	typeoperation;
	selectedValue: string = "";
	aujourdhui = new Date();
	ecloseries;
	incidents;
	embonpoints;
	frequences = environment.frequences;
	severite = environment.severite;
  revetements;
  nageoires;
  opercules;
  bouches;
  estomacs;
  intestins;
  branchies;
  coeurs;
  tetes;
  yeux;
  cerveaus;
  rates;
  foies;
  vesiculeBiliaires;
  reins;
  vessienatatoires;
	molecules: string[] = [];
	dureetraitements: string[] = [];
	formes = environment.formes;
	autre: Autres;
	autres;
	diagnostics;
	conduites;
	bacteriologiques;
	parasitaires;
	entreprises;
	fields;
	especes;
  constructor(
    public dialogRef: MatDialogRef<AddexamenComponent>,
    private formBuilder: FormBuilder,
    private TripService: ConduiteService,
    private imageService: ImageService,
    @Inject(MAT_DIALOG_DATA) public data: any,
     private storage: AngularFireStorage,
     private afs: AngularFirestore,
  ) {
  }

  ngOnInit() {
  // La confirmation de suppression n'a besoin ni des listes ni du formulaire : les lire levait une
  // erreur (data.ecloseries indéfini) à chaque ouverture de la fenêtre de suppression.
  if (this.data.list === 'delete') { return; }
  this.autres =				this.data.autres;
  this.entreprises =		this.data.entreprises;
  this.especes =			this.data.especes;
  this.ecloseries =			this.data.ecloseries.includes("*********") ? this.data.ecloseries : ["*********", ...this.data.ecloseries];
  this.diagnostics =		this.data.diagnostics;
  this.conduites =			this.data.conduites;
  this.bacteriologiques =	this.data.bacteriologiques;
  this.parasitaires =		this.data.parasitaires;
  this.incidents =			this.data.incidents.includes("*********") ? this.data.incidents : ["*********", ...this.data.incidents];
  this.embonpoints = 		this.data.embonpoints;
  this.revetements = 		this.data.revetementcutanes;
  this.nageoires =			this.data.nageoires;
  this.opercules = 			this.data.opercules;
  this.bouches = 			this.data.bouches;
  this.estomacs = 			this.data.estomacs;
  this.intestins = 			this.data.intestins;
  this.branchies = 			this.data.branchies;
  this.coeurs = 			this.data.coeurs;
  this.yeux = 				this.data.yeuxs;
  this.cerveaus = 			this.data.cerveaus;
  this.rates = 				this.data.rates;
  this.foies = 				this.data.foies;
  this.vesiculeBiliaires =  this.data.vesiculebiliaires;
  this.reins = 			 	this.data.reins;
  this.vessienatatoires = 	this.data.vessienatatoires;
  this.tetes = 	this.data.tetes;
  this.molecules =        (this.data.molecules        && this.data.molecules.length)        ? this.data.molecules        : environment.molecules;
  this.dureetraitements = (this.data.dureetraitements && this.data.dureetraitements.length) ? this.data.dureetraitements : environment.dureetraitements;

		this.initForm();
		this.configureNoFindingControls();
		this.setupAutocomplete();
		this.majAvertissements();
		this.tripForm.valueChanges.pipe(debounceTime(300), takeUntil(this.destroy$)).subscribe(() => this.majAvertissements());
		if (this.data.list === 'update') {
			this.loadExistingImages();
		}
	}

	// Valeurs numériques inhabituelles (température, poids, mortalités) : un message sous chaque champ concerné,
	// sans blocage. L'arabe est signalé, lui, par la directive ktAvertArabe posée sur les champs texte.
	avertChamps: { [champ: string]: string } = {};

	/** Examen enregistré avant le correctif du 2026-09-20 : sa « Mortalité totale » contient en réalité le nombre de jours. */
	get mortaliteAVerifier(): boolean {
		return !!(this.data && this.data.list === 'update' && this.data.examen && this.data.examen.mortaliteFiable !== true);
	}

	private majAvertissements(): void {
		this.avertChamps = avertissementsExamen(this.tripForm.value);
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	private loadExistingImages(): void {
		const ex = this.data.examen;
		const urls = [ex.imageurl, ex.imageurl1, ex.imageurl2, ex.imageurl3, ex.imageurl4];
		urls.forEach((url, i) => {
			if (url) {
				this.selectedFiles[i] = { src: url, status: 'ok', pending: false, file: null } as any;
			}
		});
	}

	private isEmptyValue(value: any): boolean {
		return value === null ||
			value === undefined ||
			value === '' ||
			(Array.isArray(value) && value.length === 0);
	}

	private isNoFindingValue(value: any): boolean {
		return typeof value === 'string' && value.trim() === DEFAULT_NO_FINDING;
	}

	private hasFindingValue(config: FindingControlConfig): boolean {
		const listControl = this.tripForm.get(config.listControl);
		const inputControl = this.tripForm.get(config.inputControl);
		const frequencyControl = config.frequencyControl ? this.tripForm.get(config.frequencyControl) : null;
		const severityControl = config.severityControl ? this.tripForm.get(config.severityControl) : null;
		const inputValue = inputControl ? inputControl.value : '';

		return !this.isEmptyValue(listControl ? listControl.value : null) ||
			(!this.isEmptyValue(inputValue) && !this.isNoFindingValue(inputValue)) ||
			!this.isEmptyValue(frequencyControl ? frequencyControl.value : null) ||
			!this.isEmptyValue(severityControl ? severityControl.value : null);
	}

	private getDefaultIncidentValue() {
		if (!this.incidents || !this.incidents.length) {
			return DEFAULT_NO_FINDING;
		}

		const defaultIncident = this.incidents.find((incident) =>
			typeof incident === 'string' &&
			incident.toLowerCase()
				.replace(/[àáâãäå]/g, 'a')
				.replace(/[éèêë]/g, 'e')
				.indexOf('rien a signal') !== -1
		);

		return defaultIncident || DEFAULT_NO_FINDING;
	}

	private configureNoFindingControls() {
		FINDING_CONTROL_CONFIGS.forEach((config) => {
			const listControl = this.tripForm.get(config.listControl);
			const inputControl = this.tripForm.get(config.inputControl);
			const frequencyControl = config.frequencyControl ? this.tripForm.get(config.frequencyControl) : null;
			const severityControl = config.severityControl ? this.tripForm.get(config.severityControl) : null;

			if (!listControl || !inputControl) {
				return;
			}

			if (this.isEmptyValue(inputControl.value)) {
				inputControl.setValue(DEFAULT_NO_FINDING, { emitEvent: false });
			}

			listControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
				if (!this.isEmptyValue(value)) {
					if (this.isEmptyValue(inputControl.value) || this.isNoFindingValue(inputControl.value)) {
						inputControl.setValue('');
					}
					return;
				}

				if (this.isEmptyValue(inputControl.value) && !this.hasFindingValue(config)) {
					inputControl.setValue(DEFAULT_NO_FINDING);
				}
			});

			inputControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
				if (this.isEmptyValue(value) && !this.hasFindingValue(config)) {
					inputControl.setValue(DEFAULT_NO_FINDING, { emitEvent: false });
				}
			});

			inputControl.valueChanges.pipe(debounceTime(600), takeUntil(this.destroy$)).subscribe((value) => {
				this.addCustomFindingOption(config, value);
			});

			[frequencyControl, severityControl].forEach((control) => {
				if (!control) {
					return;
				}

				control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
					if (!this.isEmptyValue(value) && this.isNoFindingValue(inputControl.value)) {
						inputControl.setValue('');
					}

					if (this.isEmptyValue(value) && !this.hasFindingValue(config)) {
						inputControl.setValue(DEFAULT_NO_FINDING, { emitEvent: false });
					}
				});
			});
		});
	}

	private cleanFindingValue(value: any): string {
		return this.isEmptyValue(value) ? '' : (typeof value === 'string' ? value.trim() : 'selected');
	}

	private getNoFindingInputValue(listControlName: string, inputControlName: string) {
		const config = FINDING_CONTROL_CONFIGS.find((item) =>
			item.listControl === listControlName && item.inputControl === inputControlName
		);
		const listValue = this.tripForm.get(listControlName).value;
		const inputValue = this.tripForm.get(inputControlName).value;

		return this.cleanFindingValue(listValue) === '' &&
			this.cleanFindingValue(inputValue) === '' &&
			(!config || !this.hasFindingValue(config))
			? DEFAULT_NO_FINDING
			: inputValue;
	}

	clearDefaultNoFinding(inputControlName: string): void {
		const inputControl = this.tripForm.get(inputControlName);

		if (inputControl && this.isNoFindingValue(inputControl.value)) {
			inputControl.setValue('');
		}
	}

	private addCustomFindingOption(config: FindingControlConfig, value: any): void {
		if (!config.listProperty || typeof value !== 'string') {
			return;
		}

		const cleanValue = value.trim();
		if (!cleanValue || cleanValue === DEFAULT_NO_FINDING) {
			return;
		}

		const list = this[config.listProperty];
		if (Array.isArray(list) && !list.includes(cleanValue)) {
			list.push(cleanValue);
		}
	}

	private saveCustomFindingOptions(): Promise<any[]> {
		const calls = FINDING_CONTROL_CONFIGS
			.filter((config) => !!config.collection)
			.map((config) => {
				const inputControl = this.tripForm.get(config.inputControl);
				const inputValue = inputControl ? inputControl.value : "";

				if (this.isEmptyValue(inputValue) || this.isNoFindingValue(inputValue)) {
					return Promise.resolve(null);
				}

				return this.TripService.ensureLibelleItem(config.collection, inputValue);
			});

		const molecule = (this.tripForm.get('molecule').value || '').trim();
		if (molecule) { calls.push(this.TripService.ensureLibelleItem('Molecules', molecule)); }
		const durretraitement = (this.tripForm.get('durretraitement').value || '').trim();
		if (durretraitement) { calls.push(this.TripService.ensureLibelleItem('Dureetraitements', durretraitement)); }

		return Promise.all(calls);
	}

	private persistCustomFindingOptions(): void {
		this.saveCustomFindingOptions().catch((error) => {
			console.error("Erreur pendant l'ajout des nouvelles options d'examen", error);
		});
	}

	onNoClick() {
		this.fileUrls.forEach(url => {
			if (url) { firebase.storage().refFromURL(url).delete().catch(() => {}); }
		});
		this.dialogRef.close();
	}
	selectedFiles: (ImageSnippet | null)[] = [null, null, null, null, null];

	get isUploading(): boolean { return this.fileIsUploading.some(v => v); }
	private onFileSuccess(i: number) {
		this.selectedFiles[i].pending = false;
		this.selectedFiles[i].status = "ok";
	}
	private onFileError(i: number) {
		this.selectedFiles[i].pending = false;
		this.selectedFiles[i].status = "fail";
		(this.selectedFiles[i] as any).src = "";
		this.fileIsUploading[i] = false;
		this.base64textStrings[i] = '';
	}
	initForm() {
		this.tripForm = this.formBuilder.group({
			dateExamen: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.dateExamen, [Validators.required]],
			entreprise: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.entreprise, [Validators.required]],
			numCage:    [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.numCage, [Validators.nullValidator]],
			espece:     [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.espece, [Validators.required]],
			ecloserie:  [this.data.list==='add'?"*********":this.data.list==='delete'?"":this.data.examen.ecloserie, [Validators.nullValidator]],
			tempEau:    [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.tempEau, [Validators.nullValidator]],
			dateRecepetion: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.dateRecepetion, [Validators.nullValidator]],
			pm:         [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.pm, [Validators.nullValidator]],
			mortaliteparjours: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.mortaliteparjours, [Validators.nullValidator]],
			nbrJoursMortalite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.nbrJoursMortalite, [Validators.nullValidator]],
			totalMortalite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.totalMortalite, [Validators.nullValidator]],
			incidents: [this.data.list==='add'?"*********":this.data.list==='delete'?"":(this.data.examen.incident || this.getDefaultIncidentValue()), [Validators.nullValidator]],

			embonpointobservation: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.embonpointobservation, [Validators.nullValidator]],
			embonpointobservationinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.embonpointobservationinput, [Validators.nullValidator]],
			embonpointfrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.embonpointfrequence, [Validators.nullValidator]],
			embonpointseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.embonpointseverite, [Validators.nullValidator]],

			revetement: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.revetementobservation, [Validators.nullValidator]],
			revetementinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.revetementobservationinput, [Validators.nullValidator]],
			revetementsfrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.revetementfrequence, [Validators.nullValidator]],
			revetementsseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.revetementseverite, [Validators.nullValidator]],

			nageoires: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.nageoiresobservation, [Validators.nullValidator]],
			nageoiresinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.nageoiresobservationinput, [Validators.nullValidator]],
			nageoiresfrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.nageoiresfrequence, [Validators.nullValidator]],
			nageoiresseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.nageoiresseverite, [Validators.nullValidator]],

			opercule: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.operculeobservation, [Validators.nullValidator]],
			operculeinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.operculeobservationinput, [Validators.nullValidator]],
			operculefrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.operculefrequence, [Validators.nullValidator]],
			operculeseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.operculeseverite, [Validators.nullValidator]],

			bouche: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.boucheobservation, [Validators.nullValidator]],
			boucheinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.boucheobservationinput, [Validators.nullValidator]],
			bouchefrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.bouchefrequence, [Validators.nullValidator]],
			boucheseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.boucheseverite, [Validators.nullValidator]],

			estomac: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.estomacobservation, [Validators.nullValidator]],
			estomacinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.estomacobservationinput, [Validators.nullValidator]],
			estomacfrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.estomacfrequence, [Validators.nullValidator]],
			estomacseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.estomacseverite, [Validators.nullValidator]],

			intestin: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.intestinobservation, [Validators.nullValidator]],
			intestininput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.intestinobservationinput, [Validators.nullValidator]],
			intestinfrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.intestinfrequence, [Validators.nullValidator]],
			intestinseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.intestinseverite, [Validators.nullValidator]],

			branchie: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.branchieobservation, [Validators.nullValidator]],
			branchieinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.branchieobservationinput, [Validators.nullValidator]],
			branchiefrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.branchiefrequence, [Validators.nullValidator]],
			branchieseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.branchieseverite, [Validators.nullValidator]],

			coeur: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.coeurobservation, [Validators.nullValidator]],
			coeurinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.coeurobservationinput, [Validators.nullValidator]],
			coeurfrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.coeurfrequence, [Validators.nullValidator]],
			coeurseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.coeurseverite, [Validators.nullValidator]],

			tete: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.teteobservation, [Validators.nullValidator]],
			teteinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.teteobservationinput, [Validators.nullValidator]],
			tetefrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.tetefrequence, [Validators.nullValidator]],
			teteseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.teteseverite, [Validators.nullValidator]],

			yeux: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.yeuxobservation, [Validators.nullValidator]],
			yeuxinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.yeuxobservationinput, [Validators.nullValidator]],
			yeuxfrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.yeuxfrequence, [Validators.nullValidator]],
			yeuxseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.yeuxseverite, [Validators.nullValidator]],

			cerveau: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.cerveauobservation, [Validators.nullValidator]],
			cerveauinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.cerveauobservationinput, [Validators.nullValidator]],
			cerveaufrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.cerveaufrequence, [Validators.nullValidator]],
			cerveauseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.cerveauseverite, [Validators.nullValidator]],

			rate: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.rateobservation, [Validators.nullValidator]],
			rateinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.rateobservationinput, [Validators.nullValidator]],
			ratefrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.ratefrequence, [Validators.nullValidator]],
			rateseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.rateseverite, [Validators.nullValidator]],

			foie: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.foieobservation, [Validators.nullValidator]],
			foieinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.foieobservationinput, [Validators.nullValidator]],
			foiefrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.foiefrequence, [Validators.nullValidator]],
			foieseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.foieseverite, [Validators.nullValidator]],

			vesiculeBiliaire: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.vesiculeBiliaireobservation, [Validators.nullValidator]],
			vesiculeBiliaireinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.vesiculeBiliaireobservationinput, [Validators.nullValidator]],
			vesiculeBiliairefrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.vesiculeBiliairefrequence, [Validators.nullValidator]],
			vesiculeBiliaireseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.vesiculeBiliaireseverite, [Validators.nullValidator]],

			rein: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.reinobservation, [Validators.nullValidator]],
			reininput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.reinobservationinput, [Validators.nullValidator]],
			reinfrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.reinfrequence, [Validators.nullValidator]],
			reinseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.reinseverite, [Validators.nullValidator]],

			vessienatatoire: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.vessienatatoireobservation, [Validators.nullValidator]],
			vessienatatoireinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.vessienatatoireobservationinput, [Validators.nullValidator]],
			vessienatatoirefrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.vessienatatoirefrequence, [Validators.nullValidator]],
			vessienatatoireseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.vessienatatoireseverite, [Validators.nullValidator]],

			autres: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.autresobservation, [Validators.nullValidator]],
			autresinput: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.autresobservationinput, [Validators.nullValidator]],
			autresfrequences: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.autresfrequence, [Validators.nullValidator]],
			autresseverite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.autresseverite, [Validators.nullValidator]],

			conduite: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.conduiteobservation, [Validators.nullValidator]],
      		conduitetexte: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.conduiteconduitetexte, [Validators.nullValidator]],
			molecule: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.conduitemolecule, [Validators.nullValidator]],
			durretraitement: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.conduitedurretraitement, [Validators.nullValidator]],

			rechercheparasitaire: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.rechercheparasitaireobservation, [Validators.nullValidator]],
			rechercheparasitaireForme: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.rechercheparasitaireforme, [Validators.nullValidator]],
      		parasitaire: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.parasitaire, [Validators.nullValidator]],

			recherchebacteriologique: [this.data.list==='add'?DEFAULT_NO_FINDING:this.data.list==='delete'?"":this.data.examen.recherchebacteriologiqueobservation, [Validators.nullValidator]],
			recherchebacteriologiqueforme: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.recherchebacteriologiqueforme, [Validators.nullValidator]],
      		bacteriologique: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.bacteriologique, [Validators.nullValidator]],

			diagnostic: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.diagnosticobservation, [Validators.nullValidator]],
			diagnostictexte: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.diagnosticdiagnostictexte, [Validators.nullValidator]],
			diagnosticForme: [this.data.list==='add'?"":this.data.list==='delete'?"":this.data.examen.diagnosticforme, [Validators.nullValidator]],

		//	imagename: [this.data.list==='add'?"":this.data.examen.branchie.observation, [Validators.nullValidator]],



		});
	}
  onSubmit() {
        const dateExamen = this.tripForm.get("dateExamen").value;
        const entreprise = this.tripForm.get("entreprise").value;
        const numCage = this.tripForm.get("numCage").value;
        const espece = this.tripForm.get("espece").value;
        const ecloserie = this.tripForm.get("ecloserie").value;
        const tempEau = this.tripForm.get("tempEau").value;
        const dateRecepetion = this.tripForm.get("dateRecepetion").value;
        const pm = this.tripForm.get("pm").value;
        const mortaliteparjours = this.tripForm.get("mortaliteparjours").value;
        const nbrJoursMortalite = this.tripForm.get("nbrJoursMortalite").value;
        const totalMortalite = this.tripForm.get("totalMortalite").value;
        const incidents = this.tripForm.get("incidents").value;

        const embonpointfrequences = this.tripForm.get("embonpointfrequences").value;
        const embonpointseverite = this.tripForm.get("embonpointseverite").value;
        const embonpointobservation = this.tripForm.get("embonpointobservation").value;
	  	const embonpointobservationinput = this.getNoFindingInputValue('embonpointobservation', 'embonpointobservationinput');

	  const revetementsfrequences = this.tripForm.get("revetementsfrequences").value;
        const revetementsseverite = this.tripForm.get("revetementsseverite").value;
        const revetement = this.tripForm.get("revetement").value;
        const revetementinput = this.getNoFindingInputValue('revetement', 'revetementinput');

        const nageoiresfrequences = this.tripForm.get("nageoiresfrequences").value;
        const nageoiresseverite = this.tripForm.get("nageoiresseverite").value;
        const nageoires = this.tripForm.get("nageoires").value;
        const nageoiresinput = this.getNoFindingInputValue('nageoires', 'nageoiresinput');

        const operculefrequences = this.tripForm.get("operculefrequences").value;
        const operculeseverite = this.tripForm.get("operculeseverite").value;
        const opercule = this.tripForm.get("opercule").value;
        const operculeinput = this.getNoFindingInputValue('opercule', 'operculeinput');

        const bouchefrequences = this.tripForm.get("bouchefrequences").value;
        const boucheseverite = this.tripForm.get("boucheseverite").value;
        const bouche = this.tripForm.get("bouche").value;
        const boucheinput = this.getNoFindingInputValue('bouche', 'boucheinput');

        const estomacfrequences = this.tripForm.get("estomacfrequences").value;
        const estomacseverite = this.tripForm.get("estomacseverite").value;
        const estomac = this.tripForm.get("estomac").value;
        const estomacinput = this.getNoFindingInputValue('estomac', 'estomacinput');

        const intestinfrequences = this.tripForm.get("intestinfrequences").value;
        const intestinseverite = this.tripForm.get("intestinseverite").value;
        const intestin = this.tripForm.get("intestin").value;
        const intestininput = this.getNoFindingInputValue('intestin', 'intestininput');

        const branchiefrequences = this.tripForm.get("branchiefrequences").value;
        const branchieseverite = this.tripForm.get("branchieseverite").value;
        const branchie = this.tripForm.get("branchie").value;
        const branchieinput = this.getNoFindingInputValue('branchie', 'branchieinput');

        const coeurfrequences = this.tripForm.get("coeurfrequences").value;
        const coeurseverite = this.tripForm.get("coeurseverite").value;
        const coeur = this.tripForm.get("coeur").value;
        const coeurinput = this.getNoFindingInputValue('coeur', 'coeurinput');

        const tetefrequences = this.tripForm.get("tetefrequences").value;
        const teteseverite = this.tripForm.get("teteseverite").value;
        const tete = this.tripForm.get("tete").value;
        const teteinput = this.getNoFindingInputValue('tete', 'teteinput');

        const yeuxfrequences = this.tripForm.get("yeuxfrequences").value;
        const yeuxseverite = this.tripForm.get("yeuxseverite").value;
        const yeux = this.tripForm.get("yeux").value;
        const yeuxinput = this.getNoFindingInputValue('yeux', 'yeuxinput');

        const cerveaufrequences = this.tripForm.get("cerveaufrequences").value;
        const cerveauseverite = this.tripForm.get("cerveauseverite").value;
        const cerveau = this.tripForm.get("cerveau").value;
        const cerveauinput = this.getNoFindingInputValue('cerveau', 'cerveauinput');

        const ratefrequences = this.tripForm.get("ratefrequences").value;
        const rateseverite = this.tripForm.get("rateseverite").value;
        const rate = this.tripForm.get("rate").value;
        const rateinput = this.getNoFindingInputValue('rate', 'rateinput');

        const foiefrequences = this.tripForm.get("foiefrequences").value;
        const foieseverite = this.tripForm.get("foieseverite").value;
        const foie = this.tripForm.get("foie").value;
        const foieinput = this.getNoFindingInputValue('foie', 'foieinput');

        const vesiculeBiliairefrequences = this.tripForm.get("vesiculeBiliairefrequences").value;
        const vesiculeBiliaireseverite = this.tripForm.get("vesiculeBiliaireseverite").value;
        const vesiculeBiliaire = this.tripForm.get("vesiculeBiliaire").value;
        const vesiculeBiliaireinput = this.getNoFindingInputValue('vesiculeBiliaire', 'vesiculeBiliaireinput');

        const reinfrequences = this.tripForm.get("reinfrequences").value;
        const reinseverite = this.tripForm.get("reinseverite").value;
        const rein = this.tripForm.get("rein").value;
        const reininput = this.getNoFindingInputValue('rein', 'reininput');

        const rechercheparasitaireForme = this.tripForm.get("rechercheparasitaireForme").value;
        const parasitaire = this.tripForm.get("parasitaire").value;
        const rechercheparasitaire = this.getNoFindingInputValue('parasitaire', 'rechercheparasitaire');

        const recherchebacteriologiqueforme = this.tripForm.get("recherchebacteriologiqueforme").value;
        const bacteriologique = this.tripForm.get("bacteriologique").value;
        const recherchebacteriologique = this.getNoFindingInputValue('bacteriologique', 'recherchebacteriologique');

        const diagnosticForme = this.tripForm.get("diagnosticForme").value;
        const diagnostic = this.tripForm.get("diagnostic").value;
        const diagnostictexte = this.getNoFindingInputValue('diagnostic', 'diagnostictexte');

        const conduite = this.tripForm.get("conduite").value;
        const conduitetexte = this.getNoFindingInputValue('conduite', 'conduitetexte');
        const molecule = this.tripForm.get("molecule").value;
        const durretraitement = this.tripForm.get("durretraitement").value;

        const vessienatatoirefrequences = this.tripForm.get("vessienatatoirefrequences").value;
        const vessienatatoireseverite = this.tripForm.get("vessienatatoireseverite").value;
        const vessienatatoire = this.tripForm.get("vessienatatoire").value;
        const vessienatatoireinput = this.getNoFindingInputValue('vessienatatoire', 'vessienatatoireinput');

        const autresfrequences = this.tripForm.get("autresfrequences").value;
        const autresseverite = this.tripForm.get("autresseverite").value;
        const autres = this.tripForm.get("autres").value;
        const autresinput = this.getNoFindingInputValue('autres', 'autresinput');
        //const imagename = this.tripForm.get("imagename").value;
        const [imageurl, imageurl1, imageurl2, imageurl3, imageurl4] = this.fileUrls.map(url => url || "");
		const newAgriculteur = new Examen();
		newAgriculteur.dateExamen = dateExamen;
		newAgriculteur.imageurlconvert = this.base64textStrings[0];
		newAgriculteur.imageurlconvert1 = this.base64textStrings[1];
		newAgriculteur.imageurlconvert2 = this.base64textStrings[2];
		newAgriculteur.imageurlconvert3 = this.base64textStrings[3];
		newAgriculteur.imageurlconvert4 = this.base64textStrings[4];
		newAgriculteur.imageurl = imageurl;
		newAgriculteur.imageurl1 = imageurl1;
		newAgriculteur.imageurl2 = imageurl2;
		newAgriculteur.imageurl3 = imageurl3;
		newAgriculteur.imageurl4 = imageurl4;

		newAgriculteur.bacteriologique = bacteriologique;
		newAgriculteur.parasitaire = parasitaire;
		//newAgriculteur.image.push(imageurl) ;
		newAgriculteur.entreprise = entreprise;
		newAgriculteur.numCage = numCage;
		newAgriculteur.espece = espece;
		newAgriculteur.ecloserie = ecloserie;
		newAgriculteur.tempEau = tempEau;
		newAgriculteur.dateRecepetion = dateRecepetion;
		newAgriculteur.pm = pm;
		newAgriculteur.mortaliteparjours = mortaliteparjours;
		newAgriculteur.nbrJoursMortalite = nbrJoursMortalite;
		newAgriculteur.totalMortalite = totalMortalite;
		newAgriculteur.incident = incidents;

		newAgriculteur.embonpointobservation = embonpointobservation;
		newAgriculteur.embonpointobservationinput = embonpointobservationinput;
		newAgriculteur.embonpointfrequence = embonpointfrequences;
		newAgriculteur.embonpointseverite = embonpointseverite;
		/*newAgriculteur.embonpoint ={
      frequence : embonpointfrequences,
      severite : embonpointseverite,
      observation : embonpoint
    };*/

    newAgriculteur.revetementobservation = revetement;
    newAgriculteur.revetementobservationinput = revetementinput;
		newAgriculteur.revetementfrequence = revetementsfrequences;
		newAgriculteur.revetementseverite = revetementsseverite;
		/*newAgriculteur.revetement={
      frequence : revetementsfrequences,
		severite : revetementsseverite,
		observation : revetement,
    }*/

    newAgriculteur.nageoiresobservation = nageoires;
    newAgriculteur.nageoiresobservationinput = nageoiresinput;
		newAgriculteur.nageoiresfrequence = nageoiresfrequences;
		newAgriculteur.nageoiresseverite = nageoiresseverite;
		/*newAgriculteur.nageoires={
      frequence : nageoiresfrequences,
      severite : nageoiresseverite,
      observation : nageoires
    }*/

    newAgriculteur.operculeobservation = opercule;
    newAgriculteur.operculeobservationinput = operculeinput;
		newAgriculteur.operculefrequence = operculefrequences;
		newAgriculteur.operculeseverite = operculeseverite;
		/*newAgriculteur.opercule={
      frequence : operculefrequences,
	   	severite : operculeseverite,
		  observation : opercule
    }*/

    newAgriculteur.boucheobservation = bouche;
    newAgriculteur.boucheobservationinput = boucheinput;
		newAgriculteur.bouchefrequence = bouchefrequences;
		newAgriculteur.boucheseverite = boucheseverite;
		/*newAgriculteur.bouche={
      frequence : bouchefrequences,
		  severite : boucheseverite,
		  observation : bouche
    }*/

    newAgriculteur.estomacobservation = estomac;
    newAgriculteur.estomacobservationinput = estomacinput;
		newAgriculteur.estomacfrequence = estomacfrequences;
		newAgriculteur.estomacseverite = estomacseverite;
		/*newAgriculteur.estomac={
      frequence : estomacfrequences,
		  severite : estomacseverite,
		  observation : estomac
    }*/

    newAgriculteur.intestinobservation = intestin;
    newAgriculteur.intestinobservationinput = intestininput;
		newAgriculteur.intestinfrequence = intestinfrequences;
		newAgriculteur.intestinseverite = intestinseverite;
		/*newAgriculteur.intestin={
      frequence : intestinfrequences,
		  severite : intestinseverite,
		  observation : intestin
    }*/

    newAgriculteur.branchieobservation = branchie;
    newAgriculteur.branchieobservationinput = branchieinput;
		newAgriculteur.branchiefrequence = branchiefrequences;
		newAgriculteur.branchieseverite = branchieseverite;
		/*newAgriculteur.branchie={
      frequence : branchiefrequences,
		  severite : branchieseverite,
		  observation : branchie
    }*/

    newAgriculteur.coeurobservation = coeur;
    newAgriculteur.coeurobservationinput = coeurinput;
		newAgriculteur.coeurfrequence = coeurfrequences;
		newAgriculteur.coeurseverite = coeurseverite;
		/*newAgriculteur.coeur={
      frequence : coeurfrequences,
		  severite : coeurseverite,
		  observation : coeur
    }*/

    newAgriculteur.teteobservation = tete;
    newAgriculteur.teteobservationinput = teteinput;
		newAgriculteur.tetefrequence = tetefrequences;
		newAgriculteur.teteseverite = teteseverite;
		/*newAgriculteur.tete={
      frequence :tetefrequences,
		  severite : teteseverite,
		  observation : tete
    }*/

    newAgriculteur.yeuxobservation = yeux;
    newAgriculteur.yeuxobservationinput = yeuxinput;
		newAgriculteur.yeuxfrequence = yeuxfrequences;
		newAgriculteur.yeuxseverite = yeuxseverite;
		/*newAgriculteur.yeux={
      frequence : yeuxfrequences,
		  severite : yeuxseverite,
	  	observation : yeux
    }*/

    newAgriculteur.cerveauobservation = cerveau;
    newAgriculteur.cerveauobservationinput = cerveauinput;
		newAgriculteur.cerveaufrequence = cerveaufrequences;
		newAgriculteur.cerveauseverite = cerveauseverite;
		/*newAgriculteur.cerveau={
      frequence : cerveaufrequences,
		  severite : cerveauseverite,
		  observation : cerveau
    }*/

    newAgriculteur.rateobservation = rate;
    newAgriculteur.rateobservationinput = rateinput;
		newAgriculteur.ratefrequence = ratefrequences;
		newAgriculteur.rateseverite = rateseverite;
		/*newAgriculteur.rate={
      frequence :ratefrequences,
		  severite : rateseverite,
		  observation : rate
    }*/

    newAgriculteur.foieobservation = foie;
    newAgriculteur.foieobservationinput = foieinput;
		newAgriculteur.foiefrequence = foiefrequences;
		newAgriculteur.foieseverite = foieseverite;
		/*newAgriculteur.foie={
      frequence :foiefrequences,
		  severite : foieseverite,
		  observation : foie
    }*/

    newAgriculteur.vesiculeBiliaireobservation = vesiculeBiliaire;
    newAgriculteur.vesiculeBiliaireobservationinput = vesiculeBiliaireinput;
		newAgriculteur.vesiculeBiliairefrequence = vesiculeBiliairefrequences;
		newAgriculteur.vesiculeBiliaireseverite = vesiculeBiliaireseverite;
		/*newAgriculteur.vesiculeBiliaire={
      frequence : vesiculeBiliairefrequences,
		  severite : vesiculeBiliaireseverite,
		  observation : vesiculeBiliaire
    }*/

    newAgriculteur.reinobservation = rein;
    newAgriculteur.reinobservationinput = reininput;
		newAgriculteur.reinfrequence = reinfrequences;
		newAgriculteur.reinseverite = reinseverite;
		/*newAgriculteur.rein={
      frequence : reinfrequences,
		  severite : reinseverite,
		  observation : rein
    }*/

    newAgriculteur.rechercheparasitaireforme = rechercheparasitaireForme;
		newAgriculteur.rechercheparasitaireobservation = rechercheparasitaire;
    newAgriculteur.parasitaire= parasitaire;
		/*newAgriculteur.rechercheparasitaire={
      forme : rechercheparasitaireForme,
		  observation : rechercheparasitaire,

    }*/

    newAgriculteur.recherchebacteriologiqueforme = recherchebacteriologiqueforme;
		newAgriculteur.recherchebacteriologiqueobservation = recherchebacteriologique;
    newAgriculteur.bacteriologique= bacteriologique;
		/*newAgriculteur.recherchebacteriologique={
      forme : recherchebacteriologiqueforme,
		  observation : recherchebacteriologique,
    }*/


    newAgriculteur.vessienatatoirefrequence = vessienatatoirefrequences;
		newAgriculteur.vessienatatoireseverite = vessienatatoireseverite;
		newAgriculteur.vessienatatoireobservation = vessienatatoire;
		newAgriculteur.vessienatatoireobservationinput = vessienatatoireinput;
		/*newAgriculteur.vessienatatoire={
      frequence : vessienatatoirefrequences,
		  severite :vessienatatoireseverite,
		  observation : vessienatatoire
    }*/

    newAgriculteur.diagnosticdiagnostictexte = diagnostictexte;
		newAgriculteur.diagnosticforme = diagnosticForme;
		newAgriculteur.diagnosticobservation = diagnostic;
		/*newAgriculteur.diagnostic={
      diagnostictexte : diagnostictexte,
      forme : diagnosticForme,
		  observation : diagnostic
    }*/

    newAgriculteur.conduiteconduitetexte = conduitetexte;
		newAgriculteur.conduiteobservation = conduite;
		newAgriculteur.conduitedurretraitement = durretraitement;
		newAgriculteur.conduitemolecule = molecule;
		/*newAgriculteur.conduite={
      conduitetexte:conduitetexte,
      observation : conduite,
		  molecule : molecule,
		  durretraitement : durretraitement
    }*/

    newAgriculteur.autresobservation = autres;
    newAgriculteur.autresobservationinput = autresinput;
		newAgriculteur.autresseverite = autresseverite;
		newAgriculteur.autresfrequence = autresfrequences;
		/*newAgriculteur.autres={
      observation : autres,
		  frequence : autresfrequences,
		  severite : autresseverite
    }*/

		//newAgriculteur.dateCreation = new Date();
		this.persistCustomFindingOptions();
		this.TripService.saveExamen(newAgriculteur).then(() => {});
	}
	base64textStrings: string[] = ['', '', '', '', ''];

	onFilesSelected(event: Event): void {
		const input = event.target as HTMLInputElement;
		const files = Array.from(input.files || []);
		let fileIndex = 0;
		for (let i = 0; i < this.selectedFiles.length && fileIndex < files.length; i++) {
			if (!this.selectedFiles[i]) {
				this.doProcessFile(i, files[fileIndex]);
				fileIndex++;
			}
		}
		input.value = '';
	}

	removeImage(i: number): void {
		const url = this.fileUrls[i];
		if (url) {
			firebase.storage().refFromURL(url).delete().catch(() => {});
		}
		this.selectedFiles[i] = null;
		this.fileUrls[i] = '';
		this.base64textStrings[i] = '';
		this.fileIsUploading[i] = false;
	}

	private doProcessFile(i: number, file: File): void {
		this.fileIsUploading[i] = true;
		const reader = new FileReader();
		reader.onload = (event: any) => {
			const dataUrl: string = event.target.result;
			this.selectedFiles[i] = new ImageSnippet(dataUrl, file);
			this.selectedFiles[i].pending = true;
			// Génère une version compressée pour le PDF (Firestore), upload l'original vers Storage
			Promise.all([
				this.compressForPdf(dataUrl),
				this.imageService.uploadImage(file),
			]).then(([compressed, url]) => {
				this.base64textStrings[i] = compressed;
				this.fileUrls[i] = url;
				this.fileIsUploading[i] = false;
				this.fileUploaded = true;
				this.onFileSuccess(i);
			}).catch(() => this.onFileError(i));
		};
		reader.readAsDataURL(file);
	}

	private compressForPdf(dataUrl: string): Promise<string> {
		return new Promise((resolve) => {
			const img = new Image();
			img.onload = () => {
				const MAX = 800;
				const ratio = Math.min(MAX / img.width, MAX / img.height, 1);
				const w = Math.round(img.width * ratio);
				const h = Math.round(img.height * ratio);
				const canvas = document.createElement('canvas');
				canvas.width = w; canvas.height = h;
				canvas.getContext('2d').drawImage(img, 0, 0, w, h);
				const resized = canvas.toDataURL('image/jpeg', 0.8);
				resolve(resized.split(',')[1] || '');
			};
			img.onerror = () => resolve('');
			img.src = dataUrl;
		});
	}

	private setupAutocomplete(): void {
		const applyFilter = (value: string, list: string[]): string[] => {
			const v = (value || '').toLowerCase();
			return v ? list.filter(item => item.toLowerCase().includes(v)) : [...list];
		};
		const addIfNew = (value: string, list: string[]) => {
			const clean = (value || '').trim();
			if (clean && !list.includes(clean)) {
				list.push(clean);
			}
		};
		this.filteredMolecules = [...this.molecules];
		this.filteredDureetraitements = [...this.dureetraitements];

		this.tripForm.get('molecule').valueChanges.pipe(startWith(''), takeUntil(this.destroy$)).subscribe(value => {
			this.filteredMolecules = applyFilter(value, this.molecules);
		});
		this.tripForm.get('molecule').valueChanges.pipe(debounceTime(600), takeUntil(this.destroy$)).subscribe(value => {
			addIfNew(value, this.molecules);
			this.filteredMolecules = applyFilter(value, this.molecules);
		});

		this.tripForm.get('durretraitement').valueChanges.pipe(startWith(''), takeUntil(this.destroy$)).subscribe(value => {
			this.filteredDureetraitements = applyFilter(value, this.dureetraitements);
		});
		this.tripForm.get('durretraitement').valueChanges.pipe(debounceTime(600), takeUntil(this.destroy$)).subscribe(value => {
			addIfNew(value, this.dureetraitements);
			this.filteredDureetraitements = applyFilter(value, this.dureetraitements);
		});
	}
  onUpdate(data) {
        const entreprise = this.tripForm.get("entreprise").value;
        const dateExamen = this.tripForm.get("dateExamen").value;
        const numCage = this.tripForm.get("numCage").value;
        const espece = this.tripForm.get("espece").value;
        const ecloserie = this.tripForm.get("ecloserie").value;
        const tempEau = this.tripForm.get("tempEau").value;
        const dateRecepetion = this.tripForm.get("dateRecepetion").value;
        const pm = this.tripForm.get("pm").value;
        const mortaliteparjours = this.tripForm.get("mortaliteparjours").value;
        const nbrJoursMortalite = this.tripForm.get("nbrJoursMortalite").value;
        const totalMortalite = this.tripForm.get("totalMortalite").value;
        const incidents = this.tripForm.get("incidents").value;

        const embonpointfrequences = this.tripForm.get("embonpointfrequences").value;
        const embonpointseverite = this.tripForm.get("embonpointseverite").value;
        const embonpointobservation = this.tripForm.get("embonpointobservation").value;
	  	const embonpointobservationinput = this.getNoFindingInputValue('embonpointobservation', 'embonpointobservationinput');

        const revetementsfrequences = this.tripForm.get("revetementsfrequences").value;
        const revetementsseverite = this.tripForm.get("revetementsseverite").value;
        const revetement = this.tripForm.get("revetement").value;
        const revetementinput = this.getNoFindingInputValue('revetement', 'revetementinput');

        const nageoiresfrequences = this.tripForm.get("nageoiresfrequences").value;
        const nageoiresseverite = this.tripForm.get("nageoiresseverite").value;
        const nageoires = this.tripForm.get("nageoires").value;
        const nageoiresinput = this.getNoFindingInputValue('nageoires', 'nageoiresinput');

        const operculefrequences = this.tripForm.get("operculefrequences").value;
        const operculeseverite = this.tripForm.get("operculeseverite").value;
        const opercule = this.tripForm.get("opercule").value;
        const operculeinput = this.getNoFindingInputValue('opercule', 'operculeinput');

        const bouchefrequences = this.tripForm.get("bouchefrequences").value;
        const boucheseverite = this.tripForm.get("boucheseverite").value;
        const bouche = this.tripForm.get("bouche").value;
        const boucheinput = this.getNoFindingInputValue('bouche', 'boucheinput');

        const estomacfrequences = this.tripForm.get("estomacfrequences").value;
        const estomacseverite = this.tripForm.get("estomacseverite").value;
        const estomac = this.tripForm.get("estomac").value;
        const estomacinput = this.getNoFindingInputValue('estomac', 'estomacinput');

        const intestinfrequences = this.tripForm.get("intestinfrequences").value;
        const intestinseverite = this.tripForm.get("intestinseverite").value;
        const intestin = this.tripForm.get("intestin").value;
        const intestininput = this.getNoFindingInputValue('intestin', 'intestininput');

        const branchiefrequences = this.tripForm.get("branchiefrequences").value;
        const branchieseverite = this.tripForm.get("branchieseverite").value;
        const branchie = this.tripForm.get("branchie").value;
        const branchieinput = this.getNoFindingInputValue('branchie', 'branchieinput');

        const coeurfrequences = this.tripForm.get("coeurfrequences").value;
        const coeurseverite = this.tripForm.get("coeurseverite").value;
        const coeur = this.tripForm.get("coeur").value;
        const coeurinput = this.getNoFindingInputValue('coeur', 'coeurinput');

        const tetefrequences = this.tripForm.get("tetefrequences").value;
        const teteseverite = this.tripForm.get("teteseverite").value;
        const tete = this.tripForm.get("tete").value;
        const teteinput = this.getNoFindingInputValue('tete', 'teteinput');

        const yeuxfrequences = this.tripForm.get("yeuxfrequences").value;
        const yeuxseverite = this.tripForm.get("yeuxseverite").value;
        const yeux = this.tripForm.get("yeux").value;
        const yeuxinput = this.getNoFindingInputValue('yeux', 'yeuxinput');

        const cerveaufrequences = this.tripForm.get("cerveaufrequences").value;
        const cerveauseverite = this.tripForm.get("cerveauseverite").value;
        const cerveau = this.tripForm.get("cerveau").value;
        const cerveauinput = this.getNoFindingInputValue('cerveau', 'cerveauinput');

        const ratefrequences = this.tripForm.get("ratefrequences").value;
        const rateseverite = this.tripForm.get("rateseverite").value;
        const rate = this.tripForm.get("rate").value;
        const rateinput = this.getNoFindingInputValue('rate', 'rateinput');

        const foiefrequences = this.tripForm.get("foiefrequences").value;
        const foieseverite = this.tripForm.get("foieseverite").value;
        const foie = this.tripForm.get("foie").value;
        const foieinput = this.getNoFindingInputValue('foie', 'foieinput');

        const vesiculeBiliairefrequences = this.tripForm.get("vesiculeBiliairefrequences").value;
        const vesiculeBiliaireseverite = this.tripForm.get("vesiculeBiliaireseverite").value;
        const vesiculeBiliaire = this.tripForm.get("vesiculeBiliaire").value;
        const vesiculeBiliaireinput = this.getNoFindingInputValue('vesiculeBiliaire', 'vesiculeBiliaireinput');

        const reinfrequences = this.tripForm.get("reinfrequences").value;
        const reinseverite = this.tripForm.get("reinseverite").value;
        const rein = this.tripForm.get("rein").value;
        const reininput = this.getNoFindingInputValue('rein', 'reininput');

        const rechercheparasitaireForme = this.tripForm.get("rechercheparasitaireForme").value;
        const parasitaire = this.tripForm.get("parasitaire").value;
        const rechercheparasitaire = this.getNoFindingInputValue('parasitaire', 'rechercheparasitaire');

        const recherchebacteriologiqueforme = this.tripForm.get("recherchebacteriologiqueforme").value;
        const bacteriologique = this.tripForm.get("bacteriologique").value;
        const recherchebacteriologique = this.getNoFindingInputValue('bacteriologique', 'recherchebacteriologique');

        const diagnosticForme = this.tripForm.get("diagnosticForme").value;
        const diagnostic = this.tripForm.get("diagnostic").value;
        const diagnostictexte = this.getNoFindingInputValue('diagnostic', 'diagnostictexte');

        const conduite = this.tripForm.get("conduite").value;
        const conduitetexte = this.getNoFindingInputValue('conduite', 'conduitetexte');
        const molecule = this.tripForm.get("molecule").value;
        const durretraitement = this.tripForm.get("durretraitement").value;

        const vessienatatoirefrequences = this.tripForm.get("vessienatatoirefrequences").value;
        const vessienatatoireseverite = this.tripForm.get("vessienatatoireseverite").value;
        const vessienatatoire = this.tripForm.get("vessienatatoire").value;
        const vessienatatoireinput = this.getNoFindingInputValue('vessienatatoire', 'vessienatatoireinput');

        const autresfrequences = this.tripForm.get("autresfrequences").value;
        const autresseverite = this.tripForm.get("autresseverite").value;
        const autres = this.tripForm.get("autres").value;
        const autresinput = this.getNoFindingInputValue('autres', 'autresinput');
        //const imageurl = this.fileUrl && this.fileUrl[0] !== "" ? this.fileUrl[0] : "";
		let a={
   // image :imageurl,
    dateExamen : dateExamen,
		entreprise : entreprise,
		numCage : numCage,
		espece : espece,
		ecloserie : ecloserie,
		tempEau : tempEau,
		dateRecepetion :dateRecepetion,
		pm : pm,
		mortaliteparjours : mortaliteparjours,
		nbrJoursMortalite : nbrJoursMortalite,
		totalMortalite : totalMortalite,
		incident : incidents,

    embonpointobservation : embonpointobservation,
    embonpointobservationinput : embonpointobservationinput,
    embonpointfrequence : embonpointfrequences,
    embonpointseverite : embonpointseverite,
		/*embonpoint :{
      frequence : embonpointfrequences,
      severite : embonpointseverite,
      observation : embonpoint
    },*/

    revetementobservation : revetement,
    revetementobservationinput : revetementinput,
    revetementfrequence : revetementsfrequences,
    revetementseverite : revetementsseverite,
		/*revetement:{
      frequence : revetementsfrequences,
		severite : revetementsseverite,
		observation : revetement,
    },*/

    nageoiresobservation : nageoires,
    nageoiresobservationinput : nageoiresinput,
    nageoiresfrequence : nageoiresfrequences,
    nageoiresseverite : nageoiresseverite,
		/*nageoires:{
      frequence : nageoiresfrequences,
      severite : nageoiresseverite,
      observation : nageoires
    },*/

    operculeobservation : opercule,
    operculeobservationinput : operculeinput,
    operculefrequence : operculefrequences,
    operculeseverite : operculeseverite,
		/*opercule:{
      frequence : operculefrequences,
	   	severite : operculeseverite,
		  observation : opercule
    },*/

    boucheobservation : bouche,
    boucheobservationinput : boucheinput,
    bouchefrequence : bouchefrequences,
    boucheseverite : boucheseverite,
		/*bouche:{
      frequence : bouchefrequences,
		  severite : boucheseverite,
		  observation : bouche
    },*/

    estomacobservation : estomac,
    estomacobservationinput : estomacinput,
    estomacfrequence : estomacfrequences,
    estomacseverite : estomacseverite,
		/*estomac:{
      frequence : estomacfrequences,
		  severite : estomacseverite,
		  observation : estomac
    },*/

    intestinobservation : intestin,
    intestinobservationinput : intestininput,
    intestinfrequence : intestinfrequences,
    intestinseverite : intestinseverite,
		/*intestin:{
      frequence : intestinfrequences,
		  severite : intestinseverite,
		  observation : intestin
    },*/

    branchieobservation : branchie,
    branchieobservationinput : branchieinput,
    branchiefrequence : branchiefrequences,
    branchieseverite : branchieseverite,
		/*branchie:{
      frequence : branchiefrequences,
		  severite : branchieseverite,
		  observation : branchie
    },*/

    coeurobservation : coeur,
    coeurobservationinput : coeurinput,
    coeurfrequence : coeurfrequences,
    coeurseverite : coeurseverite,
		/*coeur:{
      frequence : coeurfrequences,
		  severite : coeurseverite,
		  observation : coeur
    },*/

    teteobservation : tete,
    teteobservationinput : teteinput,
    tetefrequence : tetefrequences,
    teteseverite : teteseverite,
		/*tete:{
      frequence :tetefrequences,
		  severite : teteseverite,
		  observation : tete
    },*/

    yeuxobservation : yeux,
    yeuxobservationinput : yeuxinput,
    yeuxfrequence : yeuxfrequences,
    yeuxseverite : yeuxseverite,
		/*yeux:{
      frequence : yeuxfrequences,
		  severite : yeuxseverite,
	  	observation : yeux
    },*/

    cerveauobservation : cerveau,
    cerveauobservationinput : cerveauinput,
    cerveaufrequence : cerveaufrequences,
    cerveauseverite : cerveauseverite,
		/*cerveau:{
      frequence : cerveaufrequences,
		  severite : cerveauseverite,
		  observation : cerveau
    },*/

    rateobservation : rate,
    rateobservationinput : rateinput,
    ratefrequence : ratefrequences,
    rateseverite : rateseverite,
		/*rate:{
      frequence :ratefrequences,
		  severite : rateseverite,
		  observation : rate
    },*/

    foieobservation : foie,
    foieobservationinput : foieinput,
    foiefrequence : foiefrequences,
    foieseverite : foieseverite,
		/*foie:{
      frequence :foiefrequences,
		  severite : foieseverite,
		  observation : foie
    },*/

    vesiculeBiliaireobservation : vesiculeBiliaire,
    vesiculeBiliaireobservationinput : vesiculeBiliaireinput,
    vesiculeBiliairefrequence : vesiculeBiliairefrequences,
    vesiculeBiliaireseverite : vesiculeBiliaireseverite,
		/*vesiculeBiliaire:{
      frequence : vesiculeBiliairefrequences,
		  severite : vesiculeBiliaireseverite,
		  observation : vesiculeBiliaire
    },*/

    reinobservation : rein,
    reinobservationinput : reininput,
    reinfrequence : reinfrequences,
    reinseverite : reinseverite,
		/*rein:{
      frequence : reinfrequences,
		  severite : reinseverite,
		  observation : rein
    },*/

    rechercheparasitaireobservation : rechercheparasitaire,
    rechercheparasitaireforme : rechercheparasitaireForme,
    parasitaire: parasitaire,
		/*rechercheparasitaire:{
      forme : rechercheparasitaireForme,
		  observation : rechercheparasitaire
    },*/

    recherchebacteriologiqueobservation : recherchebacteriologique,
    recherchebacteriologiqueforme : recherchebacteriologiqueforme,
    bacteriologique: bacteriologique,
		/*recherchebacteriologique:{
      forme : recherchebacteriologiqueforme,
		  observation : recherchebacteriologique
    },*/

    vessienatatoireobservation : vessienatatoire,
    vessienatatoireobservationinput : vessienatatoireinput,
    vessienatatoirefrequence : vessienatatoirefrequences,
    vessienatatoireseverite : vessienatatoireseverite,
		/*vessienatatoire:{
      frequence : vessienatatoirefrequences,
		  severite :vessienatatoireseverite,
		  observation : vessienatatoire
    },*/

    diagnosticdiagnostictexte : diagnostictexte,
    diagnosticobservation : diagnostic,
    diagnosticforme : diagnosticForme,
		/*diagnostic:{
      diagnostictexte : diagnostictexte,
      forme : diagnosticForme,
		  observation : diagnostic
    },*/

    conduiteconduitetexte : conduitetexte,
    conduiteobservation : conduite,
    conduitemolecule : molecule,
    conduitedurretraitement : durretraitement,
		/*conduite:{
      conduitetexte:conduitetexte,
      observation : conduite,
		  molecule : molecule,
		  durretraitement : durretraitement
    },*/

    autresobservation : autres,
    autresobservationinput : autresinput,
    autresfrequence : autresfrequences,
    autresseverite : autresseverite,
		/*autres:{
      observation : autres,
		  frequence : autresfrequences,
		  severite : autresseverite
    },*/
	imageurl:        this.fileUrls[0]          || (this.selectedFiles[0] ? data.examen.imageurl         : '') || '',
	imageurlconvert:  this.base64textStrings[0] || (this.selectedFiles[0] ? data.examen.imageurlconvert  : '') || '',
	imageurl1:        this.fileUrls[1]          || (this.selectedFiles[1] ? data.examen.imageurl1        : '') || '',
	imageurlconvert1: this.base64textStrings[1] || (this.selectedFiles[1] ? data.examen.imageurlconvert1 : '') || '',
	imageurl2:        this.fileUrls[2]          || (this.selectedFiles[2] ? data.examen.imageurl2        : '') || '',
	imageurlconvert2: this.base64textStrings[2] || (this.selectedFiles[2] ? data.examen.imageurlconvert2 : '') || '',
	imageurl3:        this.fileUrls[3]          || (this.selectedFiles[3] ? data.examen.imageurl3        : '') || '',
	imageurlconvert3: this.base64textStrings[3] || (this.selectedFiles[3] ? data.examen.imageurlconvert3 : '') || '',
	imageurl4:        this.fileUrls[4]          || (this.selectedFiles[4] ? data.examen.imageurl4        : '') || '',
	imageurlconvert4: this.base64textStrings[4] || (this.selectedFiles[4] ? data.examen.imageurlconvert4 : '') || '',
    id: data.id
  }
		this.persistCustomFindingOptions();
		this.TripService.updateExamen(a, data.examen).then( res => {
		});

  }
  ondelete(id) {

		this.TripService.deleteExamen(id, this.data.examen);
    this.dialogRef.close();

  }
}
